export default "__VITE_ASSET__aQHd$iVK__ 100w";